module.exports = __webpack_public_path__ + "img/1.dfad5606.png";